"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAttendancesEndpoints = createAttendancesEndpoints;
/**
 * Katılım: kullanıcının KENDİ kaydı, başvurusu ve katılım yaşam döngüsü.
 */
function createAttendancesEndpoints(client) {
    return {
        attendances: {
            /**
             * Blok 7A dikişi (PROJE-DURUMU §6): mobil ana ekran + ajanda bu ucu
             * tüketir. Yalnızca çağıranın KENDİ kulvar kayıtları döner.
             */
            listMine: (query) => client.call('/users/me/attendances', 'get', { query: query }),
            /**
             * B-30: yanıt bekleyen etkinlik davetleri. Bekleyen davet katılım
             * DEĞİLDİR; `listMine` onu taşımaz, ana sayfanın ayrı grubu bunu okur.
             */
            listMyEventInvitations: (query) => client.call('/users/me/event-invitations', 'get', { query: query }),
            register: (eventId, input) => client.call('/events/{eventId}/registrations', 'post', { path: { eventId }, body: input }),
            myParticipation: (eventId) => client.call('/events/{eventId}/participation/me', 'get', { path: { eventId } }),
            cancel: (eventId) => client.call('/events/{eventId}/registrations/cancel', 'post', { path: { eventId } }),
            manageList: (eventId, query) => client.call('/events/{eventId}/attendees/manage', 'get', {
                path: { eventId },
                query: query,
            }),
            /** Katılımcı listesi CSV'si (B-23 A): gövde metindir, iletişim bilgisi taşımaz. */
            exportCsv: (eventId) => client.request(`/events/${encodeURIComponent(eventId)}/attendees/export`, {
                method: 'get',
                responseType: 'text',
            }),
            changeTicket: (eventId, attendanceId, input) => client.call('/events/{eventId}/attendees/{attendanceId}/ticket', 'patch', {
                path: { eventId, attendanceId },
                body: input,
            }),
            removeAttendee: (eventId, attendanceId) => client.call('/events/{eventId}/attendees/{attendanceId}', 'delete', {
                path: { eventId, attendanceId },
            }),
            /**
             * Kendi yaka kartı jetonu (ekran 20). QR'a basılan değer buradan gelir.
             */
            badge: (eventId) => client.call('/events/{eventId}/registrations/badge', 'get', { path: { eventId } }),
            /**
             * Kapıda check-in (ekran 20). `clientRequestId` İDEMPOTANS anahtarıdır:
             * çevrimdışı kuyruk aynı okutmayı tekrar gönderirse yeni yan etki olmaz.
             * Mükerrer okutma HATA DEĞİLDİR — 200 + `alreadyCheckedIn` döner.
             */
            checkIn: (eventId, input) => client.call('/events/{eventId}/check-ins', 'post', { path: { eventId }, body: input }),
            checkInSummary: (eventId) => client.call('/events/{eventId}/check-ins/summary', 'get', { path: { eventId } }),
            /** Toplu işlem (ekran 19) — `remove` yıkıcıdır, gerekçe zorunludur. */
            bulkAction: (eventId, input) => client.call('/events/{eventId}/attendees/bulk', 'post', {
                path: { eventId },
                body: input,
            }),
        },
        applications: {
            submit: (eventId, input) => client.call('/events/{eventId}/applications', 'post', { path: { eventId }, body: input }),
            queue: (eventId, query) => client.call('/events/{eventId}/applications', 'get', {
                path: { eventId },
                query: query,
            }),
            decide: (eventId, input) => client.call('/events/{eventId}/applications/decide', 'post', {
                path: { eventId },
                body: input,
            }),
        },
    };
}
//# sourceMappingURL=attendances.js.map